module.exports = __webpack_public_path__ + "assets/img/solutions6.5277b99d.png";